import { Suspense } from 'react';
import { QueryClient } from '@tanstack/react-query';
import withLazyLoading from '../../hoc/withLazyLoading';
import { validatePermission, createCrumbHandle } from '../../utilities/auth';
import Loader from '../../globalComponents/loader/DPLoader';
import { scadaLoader } from '../../pages/visualization/scadaConfigurationModule/scadaLiveSimulation/loader';

const AssetConfiguration = withLazyLoading(
  () => import('../../pages/visualization/assetConfiguration')
);
const ScadaLiveSimulation = withLazyLoading(
  () => import('../../pages/visualization/scadaConfigurationModule/scadaLiveSimulation')
);
const LayoutVisualisationConfig = withLazyLoading(
  () => import('../../pages/LayoutVisualisationConfig')
);
const CreateAssets = withLazyLoading(
  () => import('../../pages/createAssets')
);
const AssetSurvey = withLazyLoading(
  () => import('../../pages/createAssets/AssetSurvey')
);
const WelspunDemo = withLazyLoading(
  () => import('../../pages/WelspunDemo')
);
const PageListing = withLazyLoading(
  () => import('../../pages/visualization/visualizationPages/pageListing')
);
const PagesConfiguration = withLazyLoading(
  () => import('../../pages/visualization/visualizationPages/pagesConfiguration')
);
const ScadaView = withLazyLoading(
  () => import('../../pages/visualization/scadaConfigurationModule/scadaLiveSimulation/scadaView')
);

const visualizationRoutes = (queryClient: QueryClient) => [
  {
    path: '/visualization-configuration/:workspaceId/:assetId?/:id?/*',
    element: <AssetConfiguration />,    
    loader: validatePermission('Visualisation_Configuration_WE'),
    handle: createCrumbHandle('Asset Configuration'),
  },
  {
    path: '/plant-view/:workspaceId',
    element: <ScadaLiveSimulation />,
    loader: async (args: any) => {
      await validatePermission('Visualisation_View_R')(args);
      return scadaLoader(queryClient)(args);
    },
    children: [
      {
        path: ':assetId?/*',
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <ScadaView />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/asset-creation/:id?',
    element: <CreateAssets />,    
    loader: validatePermission('Visualisation_Configuration_WE'),
    handle: createCrumbHandle('Create Asset'),
  },
  {
    path: '/asset-survey/:workspaceId/:assetId?',
    element: <AssetSurvey />,    
    loader: validatePermission('PlantsList_Manage_A'),
    handle: createCrumbHandle('Asset Survey'),
  },
  {
    path: '/LayoutVisualisationConfig/:workspaceId',
    element: <LayoutVisualisationConfig />,    
    loader: validatePermission('Visualisation_Configuration_WE'),
    handle: createCrumbHandle('Asset Configuration'),
  },
  {// @obsolete
    path: '/WelspunDemo/:assetId',
    element: <WelspunDemo key={'WelspunDemo'} />,    
    handle: createCrumbHandle('Welspun Demo'),
  },
  { // @obsolete
    path: '/METL/:assetId',
    element: <WelspunDemo key={'METL'} />,    
    handle: createCrumbHandle('METL'),
  },
  {
    path: '/pages/:workspaceId',
    handle: createCrumbHandle('Pages'),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <PageListing />
          </Suspense>
        ),
      },
      {
        path: ':pageId',
        element: <PagesConfiguration />,
        handle: createCrumbHandle('Configuration'),
      },
    ]
  },
];

export default visualizationRoutes;
